import classNames from 'classnames'
import type { ReactNode } from 'react'
import React from 'react'
import { boxShadowButton } from 'styles'
import { noop } from 'utils'

import Button from '@mui/material/Button'
import { makeStyles } from '@mui/styles'

export type CommonButtonVariants = 'primary' | 'secondary' | 'tertiary'

export interface CommonButtonProps {
  'aria-label'?: string
  children?: ReactNode
  className?: string
  disabled?: boolean
  isUpperCase?: boolean
  onClick?: () => void
  type?: 'submit' | 'reset' | 'button' | undefined
  variant?: CommonButtonVariants
}

type ThemeProps = Pick<CommonButtonProps, 'isUpperCase' | 'variant'>

const useStyles = makeStyles({
  root: {
    '&&': {
      borderRadius: '0.7rem',
      boxShadow: ({ variant }: ThemeProps) => (variant ? 'inherit' : boxShadowButton),
      fontSize: '1rem',
      fontWeight: '600',
      lineHeight: '1.4rem',
      textTransform: ({ isUpperCase }: ThemeProps) => (isUpperCase ? 'uppercase' : 'inherit'),
    },
  },
})

export function CommonButton({
  'aria-label': ariaLabel = 'common',
  children,
  className = '',
  disabled = false,
  isUpperCase = true,
  onClick = noop,
  variant = 'primary',
  type = 'button',
}: CommonButtonProps) {
  const classes = useStyles({ isUpperCase, variant })
  const colorVariant = variant === 'tertiary' ? 'inherit' : variant

  if (!children) return null

  return (
    <Button
      aria-label={ariaLabel}
      className={classNames(classes.root, className)}
      color={colorVariant}
      disabled={disabled}
      onClick={onClick}
      variant={variant === 'tertiary' ? 'text' : 'contained'}
      type={type}
    >
      {children}
    </Button>
  )
}
